import React from 'react';
import Layout from '../../../components/layout';
import AccountLayout from '../../../components/account-layout';
import AccountForgotPasswordForm from '../../../components/@account-auth/account-forgot-password-form';
import { NextPage } from 'next';

const ForgotPassword: NextPage = () => (
  <Layout title="Forgot Password">
    <AccountLayout
      title="Notification"
      breadcrumb={{ url: '/', text: 'Back to home' }}
    >
      <AccountForgotPasswordForm />
    </AccountLayout>
  </Layout>
);

export default ForgotPassword;
